var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7 19.5q-2.068 0-3.534-1.477Q2 16.547 2 14.414q0-1.828 1.068-3.258a4.7 4.7 0 0 1 2.796-1.828q.568-2.155 2.272-3.492A6.1 6.1 0 0 1 12 4.5q2.66 0 4.511 1.91 1.853 1.91 1.853 4.653a3.93 3.93 0 0 1 2.602 1.394Q22 13.664 22 15.281q0 1.758-1.193 2.989t-2.898 1.23zm0-1.875h10.91q.953 0 1.613-.68t.659-1.664q0-.984-.66-1.664a2.16 2.16 0 0 0-1.613-.68h-1.363v-1.874q0-1.946-1.33-3.317Q13.887 6.375 12 6.375T8.784 7.746t-1.33 3.316H7q-1.319 0-2.25.961-.932.962-.932 2.32 0 1.36.932 2.321.931.96 2.25.961"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudOutline);
export default __webpack_public_path__ + "static/media/cloud_outline.add604ac2264840770c947597d6e7b02.svg";
export { ForwardRef as ReactComponent };